import { btn } from "@/ui/btn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";
import { showSolution } from "@/core/showSolution.js";

export function solutionBtn(parent) {
  showSolution();
  const elem = btn({
    text: "Solution",
    parent: parent,
    classes: ["solution", "btn", "controls-bar__item"],

    onClick: () => eventEmitter.emit("solution"),
  });
  return elem;
}
